import { useIntl } from 'react-intl'

import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import { useTrip } from 'tripPlanner/hooks/api/trip'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import NLPItemCreate from 'tripPlanner/components/NLPItemCreate/NLPItemCreate'

interface Props {
  tripId: string
  defaultDate?: string
}

function NLPItemAdd({
  tripId,
  defaultDate,
}: Props) {
  const intl = useIntl()
  const { data: trip } = useTrip({ tripId })
  const { closeModal, goBack } = useModalCallbacks()

  const title = intl.formatMessage({
    id: '7vZXtovJpX90P9in-p16',
    defaultMessage: 'What would you like to do?',
    description: 'Modal title for NLP-based trip item creation in the trip planner',
  })

  const subtitle = intl.formatMessage({
    id: 'zJCAS_zsJJOVBa8htVpv',
    defaultMessage: 'Type your plan',
    description: 'Modal subtitle prompting user to type their trip plan',
  })

  const loadingText = intl.formatMessage({
    id: 'GxqE7ekYQ1AdKaHwDzeR',
    defaultMessage: 'Loading...',
    description: 'Loading indicator text while trip data is being fetched',
  })

  return (
    <>
      <ModalHeader
        title={title}
        subtitle={subtitle}
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />
      <ModalBody>
        <ModalContent>
          {trip && <NLPItemCreate trip={trip} onItemCreated={closeModal} date={defaultDate} dropdownAutoHeight />}
          {!trip && loadingText}
        </ModalContent>
      </ModalBody>
    </>
  )
}

export default NLPItemAdd
